import { useState, useEffect } from 'react';
import { useTenant } from '../../../../contexts/TenantContext';
import apiService from '../../../../services/apiService';

const ThrowballCommittees = () => {
  const { siteSettings } = useTenant();
  const [committees, setCommittees] = useState([]);
  const [loading, setLoading] = useState(true);

  // Static fallback data
  const staticCommittees = [
    {
      id: 1,
      name: 'Technical Committee',
      members: [
        { designation: 'Chairman', name: 'Mr. Karam Singh', state: 'Uttar Pradesh' },
        { designation: 'Convener', name: 'Mr. T. Balavinayakam', state: 'Tamilnadu' },
        { designation: 'Member', name: 'Mr. Bala Bachchan', state: 'Madhya Pradesh' },
        { designation: 'Member', name: 'Mr. Sanjay Pande', state: 'Madhya Pradesh' },
      ]
    },
    {
      id: 2,
      name: 'Finance Committee',
      members: [
        { designation: 'Chairman', name: 'Mr. J. L. Khurana', state: 'Haryana' },
        { designation: 'Convener', name: 'Mr. Kamal Goswami', state: 'Rajasthan' },
        { designation: 'Member', name: 'Mr. M. U. Murarkar', state: 'Maharashtra' },
        { designation: 'Member', name: 'Mr. Avinash Burbure', state: 'Madhya Pradesh' },
      ]
    },
    {
      id: 3,
      name: 'Selection Committee',
      members: [
        { designation: 'Chairman', name: 'Mr. Rajesh Kumar', state: 'Delhi' },
        { designation: 'Convener', name: 'Mr. Sunil Sharma', state: 'Punjab' },
        { designation: 'Member', name: 'Ms. Priya Singh', state: 'Haryana' },
        { designation: 'Member', name: 'Mr. Vikram Yadav', state: 'Bihar' },
      ]
    },
  ];

  useEffect(() => {
    fetchCommittees();
  }, []);

  const fetchCommittees = async () => {
    try {
      setLoading(true);
      const response = await apiService.get('/public/committees');
      const data = response.data;

      if (data.success && data.data && data.data.length > 0) {
        setCommittees(data.data);
      } else {
        // Use siteSettings or static fallback
        setCommittees(siteSettings?.committees || staticCommittees);
      }
    } catch (error) {
      console.error('Error fetching committees:', error);
      setCommittees(siteSettings?.committees || staticCommittees);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="tb-page-section tb-committees-section">
      <div className="tb-container">
        {/* Top Banner */}
        <div className="tb-page-banner">
          <img src={siteSettings?.page_banners?.committees || '/theme/assets/images/banner-3.jpg'} alt="Committees Banner" />
        </div>

        {/* Page Content */}
        <div className="tb-page-content">
          <div className="tb-heading-top">
            <h1 className="tb-page-title">COMMITTEES</h1>
            <span className="tb-mini-line"></span>
          </div>

          {loading ? (
            <div className="committees-loading">
              <i className="fas fa-spinner fa-spin"></i>
              <p>Loading committees...</p>
            </div>
          ) : committees.length === 0 ? (
            <div className="committees-empty">
              <i className="fas fa-sitemap"></i>
              <p>No committees information available.</p>
            </div>
          ) : committees.map((committee) => (
            <div className="committee-block" key={committee.id}>
              {/* Committee Title with decorative lines */}
              <div className="committee-title-wrapper">
                <span className="committee-line"></span>
                <h3 className="committee-title">{committee.name}</h3>
                <span className="committee-line"></span>
              </div>

              {/* Committee Table */}
              <div className="committee-table-wrapper">
                <table className="committee-table">
                  <thead className="committee-thead">
                    <tr>
                      <th>S.No</th>
                      <th>Designation</th>
                      <th>Name</th>
                      <th>States</th>
                    </tr>
                  </thead>
                  <tbody>
                    {committee.members && committee.members.map((member, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{member.designation}</td>
                        <td>{member.name}</td>
                        <td>{member.state}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .tb-committees-section .tb-page-content {
          padding: 2rem 1rem;
        }

        .committees-loading,
        .committees-empty {
          text-align: center;
          padding: 60px 20px;
        }

        .committees-loading i,
        .committees-empty i {
          font-size: 3rem;
          color: #3f75b1;
          margin-bottom: 16px;
          display: block;
        }

        .committees-loading p,
        .committees-empty p {
          color: #666;
          font-size: 1.1rem;
        }

        .committee-block {
          margin-bottom: 3rem;
        }

        /* Committee Title with decorative lines */
        .committee-title-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 20px;
          margin-bottom: 1.5rem;
        }

        .committee-line {
          flex: 1;
          height: 1px;
          background: linear-gradient(to right, transparent, #d1d5db, transparent);
          max-width: 200px;
        }

        .committee-title {
          color: #3f75b1;
          font-size: 1.4rem;
          font-weight: 600;
          margin: 0;
          text-align: center;
          white-space: nowrap;
        }

        /* Committee Table */
        .committee-table-wrapper {
          overflow-x: auto;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        }

        .committee-table {
          width: 100%;
          border-collapse: collapse;
          background: white;
          min-width: 600px;
        }

        .committee-table thead.committee-thead {
          background: #3f75b1 !important;
        }

        .committee-table thead.committee-thead tr {
          background: #3f75b1 !important;
        }

        .committee-table thead.committee-thead th {
          background: #3f75b1 !important;
          color: white !important;
          font-weight: 600 !important;
          padding: 14px 16px !important;
          text-align: left !important;
          font-size: 0.95rem !important;
          letter-spacing: 0.3px !important;
          width: auto;
        }

        .committee-table thead.committee-thead th:first-child {
          width: 80px !important;
        }

        .committee-table thead.committee-thead th:nth-child(2) {
          width: 200px !important;
        }

        .committee-table thead.committee-thead th:last-child {
          width: 180px !important;
        }

        .committee-table tbody tr {
          border-bottom: 1px solid #e5e7eb;
          transition: background-color 0.2s;
        }

        .committee-table tbody tr:hover {
          background-color: #f8fafc;
        }

        .committee-table tbody tr:last-child {
          border-bottom: none;
        }

        .committee-table tbody td {
          padding: 14px 16px;
          color: #374151;
          font-size: 0.95rem;
        }

        .committee-table tbody tr:nth-child(even) {
          background-color: #f9fafb;
        }

        .committee-table tbody tr:nth-child(even):hover {
          background-color: #f1f5f9;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .committee-title-wrapper {
            gap: 12px;
          }

          .committee-line {
            max-width: 60px;
          }

          .committee-title {
            font-size: 1.1rem;
          }

          .committee-table thead th,
          .committee-table tbody td {
            padding: 10px 12px;
            font-size: 0.85rem;
          }
        }

        @media (max-width: 480px) {
          .committee-line {
            display: none;
          }

          .committee-title-wrapper {
            justify-content: flex-start;
          }

          .committee-title {
            font-size: 1rem;
            text-align: left;
          }
        }
      `}</style>
    </section>
  );
};

export default ThrowballCommittees;
